import React, { useEffect, useRef } from 'react';

// Open dialogs, oldest first. Escape must reach only the topmost one, or a
// form opened over a report would take the report down with it.
const openStack = [];

/**
 * Base dialog used by every tree action. Closes on Escape and on backdrop
 * click; the panel itself swallows clicks so they never reach the backdrop.
 */
const Modal = ({ show, title, subtitle, onClose, footer, size, children }) => {
  const token = useRef({});

  useEffect(() => {
    if (!show) return undefined;

    const me = token.current;
    openStack.push(me);

    const onKey = (e) => {
      if (e.key === 'Escape' && openStack[openStack.length - 1] === me) onClose();
    };
    document.addEventListener('keydown', onKey);

    return () => {
      document.removeEventListener('keydown', onKey);
      const at = openStack.indexOf(me);
      if (at !== -1) openStack.splice(at, 1);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div className="ad-modal-backdrop" onClick={onClose}>
      <div
        className={`ad-modal ${size ? `ad-modal-${size}` : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ad-modal-head">
          <div>
            <h2 className="ad-modal-title">{title}</h2>
            {subtitle && <p className="ad-modal-subtitle">{subtitle}</p>}
          </div>
          <button type="button" className="ad-modal-close" onClick={onClose} aria-label="close">
            <i className="fas fa-xmark"></i>
          </button>
        </div>

        <div className="ad-modal-body">{children}</div>

        {footer && <div className="ad-modal-foot">{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
